import { Suspense } from 'react';
import './App.css';
import rutas from './components/route-config';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import PrivateRoute from './components/PrivateRoute';

function App() {
	return (
		<BrowserRouter>
			<Suspense fallback={<div style={{ padding: '1rem', textAlign: 'center' }}>Cargando...</div>}>
				<Switch>
					{rutas.map((ruta) =>
						ruta.privado ? (
							<PrivateRoute
								key={ruta.path}
								path={ruta.path}
								exact={ruta.exact}
								component={ruta.componente}
							/>
						) : (
							<Route
								key={ruta.path}
								path={ruta.path}
								exact={ruta.exact}
								component={ruta.componente}
							/>
						)
					)}
				</Switch>
			</Suspense>
		</BrowserRouter>
	);
}

export default App;
